export default __webpack_public_path__ + "static/media/august2023-2.e2883e8b.jpg";